import { noop } from 'lodash-es'

import RE from './re'
import envRaw from './env-raw'

const warn = envRaw.showsHosthDebug ? console.warn.bind(console) : noop
const debug = envRaw.showsHosthDebug ? console.debug.bind(console) : noop

export default {
  getReferenceToUrl,
  getCheckReferenceUrl,
  getNameToUrl,
  getTagToUrl,
  getNamesRE
}

function makeToUrl(sign, lastPartRE, baseUrl) {
  return function thingToUrl(decoded) {
    const lastPart = encode(decoded)

    if (lastPartRE.test(lastPart)) {
      return baseUrl + lastPart
    } else {
      debug(
          `hosth#${sign}ToUrl: lastPart has wrong format!`
        + `\n\t lastPart: ${lastPart}`
        + `\n\t baseUrl: ${baseUrl}`
        + `\n\t lastPartRE: ${lastPartRE.toString()}`)
      return null
    }
  }
}

function makeCheckRefUrl(urlCheckRE) {
  return function checkRefUrl(url) {
    const result = urlCheckRE.test(url)
    if (!result) {
      debug(
          'hosth#checkRefUrl: ref not match to regexp!'
        + `\n\t url: ${url}`
        + `\n\t urlCheckRE: ${urlCheckRE.toString()}`)
    }
    return result
  }
}

// getNameToUrl

const youtubeNameToUrl    = makeToUrl('name', RE.IS_NAME, 'https://www.youtube.com/user/')
const instagramNameToUrl  = makeToUrl('name', RE.IS_NAME, 'https://www.instagram.com/')
const facebookNameToUrl   = makeToUrl('name', RE.IS_NAME, 'https://www.facebook.com/')
const vimeoNameToUrl      = makeToUrl('name', RE.IS_NAME, 'https://vimeo.com/')
const vineNameToUrl       = makeToUrl('name', RE.IS_NAME, 'https://vine.co/')
const soundcloudNameToUrl = makeToUrl('name', RE.IS_NAME, 'https://soundcloud.com/')
const twitterNameToUrl    = makeToUrl('name', RE.IS_NAME, 'https://twitter.com/')
const pinterestNameToUrl  = makeToUrl('name', RE.IS_NAME, 'https://pinterest.com/')
const tumblrNameToUrl     = makeToUrl('name', RE.IS_NAME, 'https://www.tumblr.com/blog/')

function getNameToUrl(postInfo) {
  if (postInfo.isUploadHost)     return null
  if (postInfo.isYoutubeHost)    return youtubeNameToUrl
  if (postInfo.isInstagramHost)  return instagramNameToUrl
  if (postInfo.isFacebookHost)   return facebookNameToUrl
  if (postInfo.isVimeoHost)      return vimeoNameToUrl
  if (postInfo.isVineHost)       return vineNameToUrl
  if (postInfo.isSoundcloudHost) return soundcloudNameToUrl
  if (postInfo.isTwitterHost)    return twitterNameToUrl
  if (postInfo.isPinterestHost)  return pinterestNameToUrl
  if (postInfo.isTumblrHost)     return tumblrNameToUrl

  warn('hosth#getNameToUrl: unknown host:', postInfo.shortInfo())
  return null
}

// getReferenceToUrl

const youtubeRefToUrl    = makeToUrl('ref', RE.IS_YB_HASH_REF, 'https://www.youtube.com/channel/UC')
const instagramRefToUrl  = makeToUrl('ref', RE.IS_REF, 'https://www.instagram.com/')
const vimeoRefToUrl      = makeToUrl('ref', RE.IS_REF, 'https://vimeo.com/')
const vineRefToUrl       = makeToUrl('ref', RE.IS_REF, 'https://vine.co/')
const soundcloudRefToUrl = makeToUrl('ref', RE.IS_REF, 'https://soundcloud.com/')
const twitterRefToUrl    = makeToUrl('ref', RE.IS_REF, 'https://twitter.com/')
const pinterestRefToUrl  = makeToUrl('ref', RE.IS_REF, 'https://pinterest.com/')
const tumblrRefToUrl     = makeToUrl('ref', RE.IS_REF, 'https://www.tumblr.com/blog/')

function getReferenceToUrl(postInfo) {
  if (postInfo.isUploadHost)     return null
  if (postInfo.isYoutubeHost)    return youtubeRefToUrl
  if (postInfo.isInstagramHost)  return instagramRefToUrl
  // https://linear.app/gleamio/issue/GLM-6481
  if (postInfo.isFacebookHost)   return null
  if (postInfo.isVimeoHost)      return vimeoRefToUrl
  if (postInfo.isVineHost)       return vineRefToUrl
  if (postInfo.isSoundcloudHost) return soundcloudRefToUrl
  if (postInfo.isTwitterHost)    return twitterRefToUrl
  if (postInfo.isPinterestHost)  return pinterestRefToUrl
  if (postInfo.isTumblrHost)     return tumblrRefToUrl

  warn('hosth#getReferenceToUrl: unknown host:', postInfo.shortInfo())
  return null
}

// getCheckReferenceUrl

const checkYoutubeRefUrl    = makeCheckRefUrl(RE.IS_YOUTUBE)
const checkInstagramRefUrl  = makeCheckRefUrl(RE.IS_INSTAGRAM)
const checkFacebookRefUrl   = makeCheckRefUrl(RE.IS_FACEBOOK)
const checkVimeoRefUrl      = makeCheckRefUrl(RE.IS_VIMEO)
const checkVineRefUrl       = makeCheckRefUrl(RE.IS_VINE)
const checkSoundcloudRefUrl = makeCheckRefUrl(RE.IS_SOUNDCLOUD)
const checkTwitterRefUrl    = makeCheckRefUrl(RE.IS_TWITTER)
const checkPinterestRefUrl  = makeCheckRefUrl(RE.IS_PINTEREST)
const checkTumblrRefUrl     = makeCheckRefUrl(RE.IS_TUMBLR)

function getCheckReferenceUrl(postInfo) {
  if (postInfo.isUploadHost)     return null
  if (postInfo.isYoutubeHost)    return checkYoutubeRefUrl
  if (postInfo.isInstagramHost)  return checkInstagramRefUrl
  if (postInfo.isFacebookHost)   return checkFacebookRefUrl
  if (postInfo.isVimeoHost)      return checkVimeoRefUrl
  if (postInfo.isVineHost)       return checkVineRefUrl
  if (postInfo.isSoundcloudHost) return checkSoundcloudRefUrl
  if (postInfo.isTwitterHost)    return checkTwitterRefUrl
  if (postInfo.isPinterestHost)  return checkPinterestRefUrl
  if (postInfo.isTumblrHost)     return checkTumblrRefUrl

  warn('hosth#getCheckReferenceUrl: unknown host:', postInfo.shortInfo())
  return null
}

// getTagToUrl

const youtubeTagToUrl    = makeToUrl('tag', RE.IS_TAG, 'https://www.youtube.com/results?q=%23')
const instagramTagToUrl  = makeToUrl('tag', RE.IS_TAG, 'https://www.instagram.com/explore/tags/')
const facebookTagToUrl   = makeToUrl('tag', RE.IS_TAG, 'https://www.facebook.com/hashtag/')
const vimeoTagToUrl      = makeToUrl('tag', RE.IS_TAG, 'https://vimeo.com/tag:')
const vineTagToUrl       = makeToUrl('tag', RE.IS_TAG, 'https://vine.co/tags/')
const soundcloudTagToUrl = makeToUrl('tag', RE.IS_TAG, 'https://soundcloud.com/tags/')
const twitterTagToUrl    = makeToUrl('tag', RE.IS_TAG, 'https://twitter.com/hashtag/')
const pinterestTagToUrl  = makeToUrl('tag', RE.IS_TAG, 'https://pinterest.com/explore/')
const tumblrTagToUrl     = makeToUrl('tag', RE.IS_TAG, 'https://www.tumblr.com/search/')

function getTagToUrl(postInfo) {
  if (postInfo.isUploadHost)     return null
  if (postInfo.isYoutubeHost)    return youtubeTagToUrl
  if (postInfo.isInstagramHost)  return instagramTagToUrl
  if (postInfo.isFacebookHost)   return facebookTagToUrl
  if (postInfo.isVimeoHost)      return vimeoTagToUrl
  if (postInfo.isVineHost)       return vineTagToUrl
  if (postInfo.isSoundcloudHost) return soundcloudTagToUrl
  if (postInfo.isTwitterHost)    return twitterTagToUrl
  if (postInfo.isPinterestHost)  return pinterestTagToUrl
  if (postInfo.isTumblrHost)     return tumblrTagToUrl

  warn('hosth#getTagToUrl: unknown host:', postInfo.shortInfo())
  return null
}

// getNamesRE

function getNamesRE(postInfo) {
  if (postInfo.isUploadHost)     return null
  if (postInfo.isYoutubeHost)    return RE.YOUTUBE_NAMES
  if (postInfo.isInstagramHost)  return RE.INSTAGRAM_NAMES
  if (postInfo.isFacebookHost)   return RE.FACEBOOK_NAMES
  if (postInfo.isVimeoHost)      return RE.VIMEO_NAMES
  if (postInfo.isVineHost)       return RE.VINE_NAMES
  if (postInfo.isSoundcloudHost) return RE.SOUNDCLOUD_NAMES
  if (postInfo.isTwitterHost)    return RE.TWITTER_NAMES
  if (postInfo.isPinterestHost)  return RE.PINTEREST_NAMES
  if (postInfo.isTumblrHost)     return RE.TUMBLR_NAMES

  warn('hosth#getNamesRE: unknown host:', postInfo.shortInfo())
  return null
}

// helpers

function encode(uriComponent) {
  return window.encodeURIComponent(uriComponent)
}
